function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3474 22.919C21.3474 23.9788 20.4883 24.838 19.4285 24.838C18.3686 24.838 17.5095 23.9788 17.5095 22.919C17.5095 21.8592 18.3686 21 19.4285 21C20.4883 21 21.3474 21.8592 21.3474 22.919ZM23.3474 22.919C23.3474 25.0834 21.5929 26.838 19.4285 26.838C17.2641 26.838 15.5095 25.0834 15.5095 22.919C15.5095 20.7546 17.2641 19 19.4285 19C21.5929 19 23.3474 20.7546 23.3474 22.919ZM18 27.8115C15.2386 27.8115 13 30.0501 13 32.8115V36.3292C13 36.8815 13.4477 37.3292 14 37.3292C14.5523 37.3292 15 36.8815 15 36.3292V32.8115C15 31.1547 16.3431 29.8115 18 29.8115H20.5663C22.2231 29.8115 23.5663 31.1547 23.5663 32.8115V36.3292C23.5663 36.8815 24.014 37.3292 24.5663 37.3292C25.1186 37.3292 25.5663 36.8815 25.5663 36.3292V32.8115C25.5663 30.0501 23.3277 27.8115 20.5663 27.8115H18Z",
  fill: "#3C3C3B"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33,
  y: 21,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#3C3C3B"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33,
  y: 25,
  width: 14,
  height: 2,
  rx: 1,
  fill: "#3C3C3B"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33,
  y: 33,
  width: 14,
  height: 2,
  rx: 1,
  fill: "#3C3C3B"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33,
  y: 29,
  width: 12,
  height: 2,
  rx: 1,
  fill: "#3C3C3B"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1,
  y: 7,
  width: 62,
  height: 43,
  rx: 3,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 14,
  r: 1,
  fill: "#3C3C3B"
});

var _ref9 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 56,
  cy: 14,
  r: 1,
  fill: "#3C3C3B"
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 56,
  cy: 43,
  r: 1,
  fill: "#3C3C3B"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 43,
  r: 1,
  fill: "#3C3C3B"
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 7,
  y: 4,
  width: 51,
  height: 3,
  rx: 1,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 12,
  y: 1,
  width: 41,
  height: 3,
  rx: 1,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var SvgFeatureOne7 = function SvgFeatureOne7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 51,
    viewBox: "0 0 64 51",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeatureOne7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FeatureOne-7.57623774.svg";
export { ForwardRef as ReactComponent };